import { projectRequest } from 'api';
import { IPopupListResponse } from './types';

/**
 * GET /announcements/popups - Get prioritized popup notification lists
 * 
 * @returns Popup consent and info announcement lists
 */
export const getPopupList = async (): Promise<IPopupListResponse> => {
  try {
    const response = await projectRequest(false, 'v2').get<IPopupListResponse>('/announcements/popups');
    return response.data;
  } catch (error) {
    console.error('Failed to get popup lists:', error);
    throw error;
  }
};
